/**
 * This JS file contains utility functions used for VPS code
 * This should NOT be deferred and should be loaded as close to the top as possible so it is available for use when ready
 */
const VPSEvent_jQueryLoaded = new Event('vps:jquery:loaded');

window.addEventListener("load", function(){
    if(typeof($) != "undefined")
    {
        window._$ = $;
        window.dispatchEvent(VPSEvent_jQueryLoaded);
    }
    else if(typeof(Checkout) != "undefined" && typeof(Checkout.$) != "undefined")
    {
        window._$ = Checkout.$;
        window.dispatchEvent(VPSEvent_jQueryLoaded);
    }
    else
        console.log("$ is undefined");
});

if(!window.VPS_Utilities)
{
    window.VPS_Utilities = {
        formatPrice: function(price_in)
        {
            if(!price_in || !price_in.toString())
                price_in = 0;

            let p = 0;

            try {
                p = price_in.toString().replaceAll(/[^0-9.]/g, '');
            }
            catch (ex)
            {
                p = "0";
            }
            p = parseFloat(p).toFixed(2);
            let parr = p.split('.');
            if(parr.length == 1)
                parr.push('00');
            if(parr[1].length == 1)
                parr[1] = '0' + parr[1];

            if(parseInt(parr[0]) >= 1000)
            {
                let tmp = parr[0].split('').reverse();
                let pFinal = [];

                for(let x = 0; x < tmp.length; x++)
                {
                    pFinal.unshift(tmp[x]);

                    if(((x+1)%3 == 0) && (x < (tmp.length - 1)))
                        pFinal.unshift(',');
                }

                parr[0] = pFinal.join('');
            }

            return '$' + parr.join('.');
        }
    };
}

/**********************************************************
 * VPS COOKIE MANAGER
 **********************************************************/
let VPSCookieManager = {
    getCookie: function(name)
    {
        const cval = '; ' + document.cookie;
        const find = '; ' + name + '=';
        const parts = cval.split(find);
        if (parts.length === 2)
            return parts.pop().split(';').shift();

        return "";
    },

    setCookie: function(name, value, path="/", domain=null, secure=true, samesite="strict", expires=null)
    {
        document.cookie = this.generateCookieValue(name, value, path, domain, secure, samesite, expires);
    },

    eraseCookie: function(name, path="/", domain=null, secure=true, samesite="strict")
    {
        this.setCookie(name, "", path, domain, secure, samesite, new Date(0));
    },

    generateCookieValue: function(name, value, path="/", domain=null, secure=true, samesite="strict", expires=null)
    {
        let valArr = [
            name + "=" + value,
            "path=" + path,
            "secure=" + secure,
            "samesite=" + samesite
        ];

        if(domain != null)
            valArr.push("domain=" + domain);

        if(expires != null)
            valArr.push("expires=" + expires.toUTCString());

        return valArr.join("; ");

    },

    _parseCookieValue: function(cookie)
    {
        const cval = '; ' + document.cookie;
    }
};
